import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable, of} from "rxjs";
import {environment} from "../../../environments/environment.prod";
import {CrmSubAgent} from "../interfaces/crm-sub-agent";
import {CrmItem} from "../interfaces/crm-item";
import {catchError} from "rxjs/operators";
import {MessageService} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class LeadService {

  constructor(private http: HttpClient, private messageService: MessageService) {
  }

  generateAddressString(address:any):string {
    if(!address) {
      return '';
    }

    const parts = [
      { value: address?.index, type: '' },
      { value: address?.region, type: '' },
      { value: address?.area, type: '' },
      { value: address?.city, type: address?.city_type?.trim() },
      { value: address?.city2, type: address?.city_type_2?.trim() },
      { value: address?.street, type: address?.street_type?.trim() },
      { value: address?.house, type: address?.house_type?.trim() },
      { value: address?.pavilion, type: address?.pavilion_type?.trim() },
      { value: address?.building, type: address?.building_type?.trim() },
      { value: address?.flat, type: address?.flat_type?.trim() },
    ];

    return parts
      .filter(part => part.value?.length)
      .map(part => (part.type ? `${part.type} ${part.value}` : part.value))
      .join(', ');
  }

  requestSubAgents(): Observable<CrmSubAgent[]> {
    return this.http.get<CrmSubAgent[]>(environment.serverUrl + 'crm/sub_agents');
  }

  getFailureReasons(): Observable<any> {
    return this.http.get<any>(environment.serverUrl + 'crm/failure_reasons');
  }

  requestBaseContracts(projectid: string): Observable<CrmItem[]|null> {
    return this.http.get<CrmSubAgent[]>(environment.serverUrl + 'asrvtc/base_contracts?project_id='+projectid);
  }
}
